import GraphQLClient from '../../core/adapter/graphQLClient';
import Product from '../../entity/product';
import Session from '../../entity/session';
import getProducts from './query/getProducts';
import getProduct from './query/getProduct';
import updateProduct from './mutation/updateProduct';
import paginatify from '../../utility/paginatify';
import PageInfo, {
  PageConditions,
} from '../../entity/pageInfo';
import { SearchProductInputType } from "../../state/contentSelect";

export type OrderTargetType = 'id' | 'sort';
export type OrderDirectionType = 'asc' | 'desc';
export type OrderType = {
  target: OrderTargetType,
  direction: OrderDirectionType,
}

class ProductRepository {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getProducts(
    session: Session,
    storeId: string,
    conditions?: PageConditions,
    name?: string,
    searchInput?: SearchProductInputType,
  ): Promise<{ records: Product[], pageInfo: PageInfo }> {
    return this.graphqlClient
      .query(session, getProducts, { variables: { storeId, searchInput, name, ...conditions } })
      .then(({ data }: { data: any }) => {
        const { edges, pageInfo } = paginatify(data['productsByStore']);
        const records = edges.map((item: any) => {
          return Product.fromJson(item);
        });
        const newPageInfo = PageInfo.fromJson(pageInfo);

        return { records, pageInfo: newPageInfo };
      });
  }

  public getProduct(session: Session, { id, manageId } : { id?: string, manageId?: string }): Promise<Product> {
    return this.graphqlClient
      .query(session, getProduct, { variables: { id, manageId } })
      .then(({ data }: { data: any }) => Product.fromJson(data['productByStore']));
  }

  public save(
    session: Session,
    {
      id,
      manageId,
      count,
      orderId,
    }: {
      id?: string,
      manageId?: string,
      count: number,
      orderId: string
    },
  ) {
    const mutation = updateProduct;
    const mutationName = 'updateProductForOrder';
    return this.graphqlClient
      .mutate(session, mutation, { variables: { orderId, id, manageId, count }})
      .then(({ data }: { data: any }) => Product.fromJson(data[mutationName]));
  }
}

export default ProductRepository;
